import React, { useState, useEffect, useRef } from "react";
import "./PatientSettings.css";
import { useParams, useNavigate } from "react-router-dom";
//import Menu from "../../components/menu/Menu";
import axios from "axios";
import Select from "../select/Select";
import moment from "moment";
import { checkParams } from "../../../src/util/Util";
import LoadingButtonText from "../loadingButtonText/loadingButtonText";

const PatientSettings = (props) => {
  const id = useParams().userid;
  const navigate = useNavigate();
  const [patientSettings, setPatientSettings] = useState([]);
  const [titleName, setTitleName] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [errorSelectedState, setErrorSelectedState] = useState("");
  const [selectedTab, setSelectedTab] = useState("personal_info");
  const [canadaStateList, setCanadaStateList] = useState([]);
  const [unitedStateStateList, setUnitedStateStateList] = useState([]);
  const [genderList] = useState([
    { value: "Male" },
    { value: "Female" },
    { value: "Other" },
  ]);
  const [countryList] = useState([
    {
      value: "United States",
    },
    { value: "Canada" },
  ]);
  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  //const [email, setEmail] = useState("");
  const [
    errorEmail,
    //setErrorEmail
  ] = useState("");
  const [phone, setPhone] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [birthday, setBirthday] = useState("");
  const [errorBirthDay, setErrorBirthDay] = useState("");
  const [address, setAddress] = useState("");
  const [errorAddress, setErrorAddress] = useState("");
  const [city, setCity] = useState("");
  const [errorCity, setErrorCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [errorZipCode, setErrorZipCode] = useState("");
  const [genderValue, setGenderValue] = useState("");
  //const [errorGender, setErrorGender] = useState("");
  const [height, setHeight] = useState("");
  const [errorHeight, setErrorHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [errorWeight, setErrorWeight] = useState("");

  /* const [timeValues, setTimeValues] = useState([{ value: 5 }, { value: 10 }, { value: 15 }]);
  const [endOfWeekTimeValues, setEndOfWeekTimeValues] = useState([
    { value: "Friday" },
    { value: "Saturday" },
    { value: "Sunday" },
  ]);
  const [timeValuesFormat, setTimeValuesFormat] = useState([{ value: "Minutes" }, { value: "Hours" }]); */
  //Error states
  const [isHandled, setIsHandled] = useState(false);
  const [hasEditBeenUsed, setHasEditBeenUsed] = useState(false);
  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);

  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  useEffect(() => {
    props.actSidebar(false);
    if (id && id !== undefined && id !== null && id !== 0) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/patient_settings_details", {
          id,
        })
        .then((res) => {
          if (res.data.responseData) {
            if (
              res.data.responseData.first_name &&
              res.data.responseData.last_name
            ) {
              let fullName =
                res.data.responseData.first_name +
                " " +
                res.data.responseData.last_name;
              setTitleName(fullName);
            }
            setFirstName(res.data.responseData.first_name);
            setLastName(res.data.responseData.last_name);
            setPhone(res.data.responseData.phone);
            setBirthday(
              moment(res.data.responseData.birthday).format("MM/DD/YYYY")
            );
            setAddress(res.data.responseData.address1);
            setCity(
              res.data.responseData.city !== "city"
                ? res.data.responseData.city
                : ""
            );
            setZipCode(res.data.responseData.zipcode);
            setGenderValue(res.data.responseData.gender);
            setHeight(res.data.responseData.height);
            setWeight(res.data.responseData.weight);
            setSelectedCountry(res.data.responseData.country);
            setSelectedState(res.data.responseData.state);
            setPatientSettings(res.data.responseData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, [id, isHandled]);

  useEffect(() => {
    axios
      .post(window.ajaxLink + "cloud_therapist/getStateList", {})
      .then((res) => {
        if (res.data.responseData) {
          var unitedStates = [];
          var canada = [];

          for (var country of res.data.responseData) {
            if (country.country === "United States") {
              unitedStates.push(country);
            } else {
              canada.push(country);
            }
          }

          setCanadaStateList(canada);
          setUnitedStateStateList(unitedStates);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleCountrySelected = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.country = value;
      setPatientSettings(settingsObj);
      setSelectedState("");
    }
  };

  const handlStateSelected = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.state = value;
      setPatientSettings(settingsObj);
      setErrorSelectedState("");
    }
  };

  const handleGenderSelected = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.gender = value;
      setPatientSettings(settingsObj);
    }
  };

  const handleSettingsObj = (key, value) => {
    let settingsObj = { ...patientSettings };
    settingsObj[key] = value;
    setPatientSettings(settingsObj);
  };

  const handleFirstName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setFirstName(val);
    if (!checkParams(val, "firstname")) {
      setErrorFirstName("Please enter a valid first name.");
    } else if (val.length > 15) {
      setErrorFirstName("First name must be no longer than 15 letters.");
    } else if (val.length < 2) {
      setErrorFirstName("First name must be longer than 2 letters.");
    } else {
      setErrorFirstName("");
    }
  };

  const handleLastName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setLastName(val);
    if (!checkParams(val, "lastname")) {
      setErrorLastName("Please enter a valid last name.");
    } else if (val.length > 15) {
      setErrorLastName("Last name must be no longer than 15 letters.");
    } else if (val.length < 2) {
      setErrorLastName("Last name must be longer than 2 letters.");
    } else {
      setErrorLastName("");
    }
  };

  const handlePhone = (subjectString) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    setErrorPhone("");

    if (phoneRegex.test(subjectString)) {
      var formattedPhoneNumber = subjectString.replace(
        phoneRegex,
        "($1) $2-$3"
      );
      setPhone(formattedPhoneNumber);
    } else {
      setErrorPhone("Please enter a valid US mobile number.");
      setPhone(subjectString);
    }
  };

  const testDateValidity = (opt) => {
    let reg = /^(?:(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)[0-9]{2})$/;

    if (reg.test(opt)) {
      var fixedOpt = opt.replace(
        reg,
        "$1/$2/$3" + opt[opt.length - 2] + opt[opt.length - 1]
      );
      const nowYear = new Date().getFullYear();
      let yearToCompare = fixedOpt.split("/");
      let isAdultValidation = parseInt(nowYear) - parseInt(yearToCompare[2]);
      if (isAdultValidation < 18) {
        return false;
      }
      return fixedOpt;
    } else {
      return false;
    }
  };

  const handleBirthday = (val) => {
    var strippedValue = val;
    // eslint-disable-next-line
    if (/[\/]/.test(strippedValue)) {
      strippedValue = strippedValue.split("/");
      strippedValue = strippedValue.join("");
    }
    // eslint-disable-next-line
    if (/[\.]/.test(strippedValue)) {
      strippedValue = strippedValue.split(".");
      strippedValue = strippedValue.join("");
    }

    if (!!testDateValidity(strippedValue) === true) {
      if (errorBirthDay) {
        setErrorBirthDay("");
      }
      setBirthday(testDateValidity(strippedValue));
    } else {
      setBirthday(val);
      if (!errorBirthDay) {
        setErrorBirthDay("Please enter a valid birthday.");
      }
    }

    /*  if (!checkParams(strippedValue, "birthday")) {
      setErrorBirthDay("Please enter a valid birthday.");
    } else {
      setErrorBirthDay("");
    } */
  };

  const handleAddress = (val) => {
    setAddress(val);
    if (!checkParams(val, "address")) {
      setErrorAddress("Please enter a valid address.");
    } else {
      setErrorAddress("");
    }
  };

  const handleCity = (val) => {
    setCity(val);
    if (!checkParams(val, "city")) {
      setErrorCity("Please enter a valid city.");
    } else {
      setErrorCity("");
    }
  };

  const handleZipCode = (val) => {
    setZipCode(val);
    if (!checkParams(val, "zipcode")) {
      setErrorZipCode("Please enter a valid zip code.");
    } else {
      setErrorZipCode("");
    }
  };

  const handleHeight = (val) => {
    setHeight(val);
    if (checkParams(val, "hasLetter")) {
      setErrorHeight("Please enter a valid height in numbers.");
    } else {
      setErrorHeight("");
    }
  };

  const handleWeight = (val) => {
    setWeight(val);
    if (val.length > 3) {
      setErrorWeight("The maximum number of digits to enter is 3.");
    } else if (checkParams(val, "hasLetter")) {
      setErrorWeight("Please enter a weight in numbers.");
    } else if (checkParams(val, "hasSpecChar")) {
      setErrorWeight(
        "Please enter a weight that doesn't contain special characters."
      );
    } else {
      setErrorWeight("");
    }
  };
  const [alreadySaving, setAlreadySaving] = useState(false);
  const handleUpdatePatientSettings = () => {
    setAlreadySaving(true);
    if (
      errorFirstName ||
      errorLastName ||
      errorPhone ||
      errorBirthDay ||
      errorAddress ||
      errorCity ||
      errorZipCode ||
      errorHeight ||
      errorWeight ||
      !selectedState
    ) {
      if (!selectedState) {
        setErrorSelectedState("Please select a valid state/province");
      }
      setErrorPopUp("Please fill in all the fields correctly.");
      return;
    }

    const newPatientSettings = {
      id: id,
      address1: address,
      birthday: birthday,
      city: city === "" ? "city" : city,
      country: selectedCountry,
      email: patientSettings.email,
      first_name: firstName,
      gender: genderValue,
      height: height,
      last_name: lastName,
      phone: phone,
      state: selectedState,
      weight: weight,
      zipcode: zipCode,
    };
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/updatePatientSettings", {
        newPatientSettings,
      })
      .then((res) => {
        if (res.data.responseData) {
          setIsHandled(!isHandled);
          setHasEditBeenUsed(true);
          setErrorPopUp("Info have been successfully saved.");
          setTimeout(() => {
            setAlreadySaving(false);
            navigate(-1);
          }, 2000);
          /* window.location.href = "/myPatients"; */
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="patient_settings_container">
      <div className="prog_det_top_hold patient_hold">
        <div className="prog_det_back">
          <div
            onClick={() => (hasEditBeenUsed ? "" : navigate(-1))}
            style={{ textDecoration: "none" }}
          >
            <div className="prog_back_icon"></div>
            <div className="prog_det_back_text">Back to Patient </div>
          </div>
          {/* <div className="saveSettingsButton" onClick={handleUpdatePatientSettings}>
            Save
          </div> */}
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0rem 1rem",
          }}
        >
          <div
            className={
              "prog_det_title_hold" +
              (selectedTab === "personal_info"
                ? " patient_settings_resize"
                : " team_resize")
            }
            style={{ flex: 1 }}
          >
            <div className="prog_det_title">{titleName}</div>
          </div>
          {!alreadySaving ? (
            <div
              className="prog_edit_btn"
              onClick={() => handleUpdatePatientSettings()}
            >
              Save Settings
            </div>
          ) : (
            <div className="prog_edit_btn" style={{cursor: "not-allowed"}}><LoadingButtonText loading={true} loadingText={"Saving Settings..."} /></div>
          )}
        </div>
      </div>
      <div className="prog_det_top_hold">
        {/* <div className="patient_settings_inner_form_container"> */}
        {/* <div className="tab_holder">
          <div
            className={
              "settings_tab " +
              (selectedTab === "personal_info" ? "settings_tab_selected" : "")
            }
            onClick={() => setSelectedTab("personal_info")}
          >
            Personal Info
          </div> */}

        {/* <div
            className={"settings_tab " + (selectedTab === "notifications" ? "settings_tab_selected" : "")}
            onClick={() => setSelectedTab("notifications")}
          >
            Notifications
          </div> */}
        {/* </div> */}
        <div className="settings_holder">
          <div className="input_wrapper">
            {selectedTab === "personal_info" && (
              <>
                <div className="info_title">Name</div>
                <div className="patient_form_row_container">
                  <input
                    type="text"
                    value={firstName}
                    className="patient_info_input"
                    // onChange={(e) => handleSettingsObj("first_name", e.currentTarget.value)}
                    onChange={(e) => handleFirstName(e.currentTarget.value)}
                  />
                  <input
                    type="text"
                    value={lastName}
                    className="patient_info_input"
                    onChange={(e) => handleLastName(e.currentTarget.value)}
                  />
                </div>
                {(errorFirstName || errorLastName) && (
                  <div className="email_error_msg">
                    {errorFirstName || errorLastName}
                  </div>
                )}
                <div className="patient_form_row_container">
                  <div className="patient_form_one_item">
                    <div className="info_title">Email Address</div>
                    <input
                      type="text"
                      value={patientSettings.email}
                      className="patient_info_input disabled_settings_input"
                      onChange={(e) =>
                        handleSettingsObj("email", e.currentTarget.value)
                      }
                      disabled={true}
                    />
                    {errorEmail && (
                      <div className="email_error_msg">{errorEmail}</div>
                    )}
                  </div>

                  <div className="patient_form_one_item">
                    <div className="info_title">Phone Number</div>
                    <input
                      type="text"
                      value={phone}
                      className="patient_info_input"
                      onChange={(e) => handlePhone(e.currentTarget.value)}
                    />
                    {errorPhone && (
                      <div className="email_error_msg">{errorPhone}</div>
                    )}
                  </div>
                </div>

                <div className="patient_form_row_container">
                  <div className="patient_form_one_item">
                    <div className="info_title">Birth Day</div>
                    <input
                      type="text"
                      value={birthday}
                      className="patient_info_input"
                      onChange={(e) => handleBirthday(e.currentTarget.value)}
                    />
                    {errorBirthDay && (
                      <div className="email_error_msg">{errorBirthDay}</div>
                    )}
                  </div>
                  <div className="patient_form_one_item">
                    <div className="info_title">Address</div>
                    <input
                      type="text"
                      value={address}
                      className="patient_info_input"
                      onChange={(e) => handleAddress(e.currentTarget.value)}
                    />
                    {errorAddress && (
                      <div className="email_error_msg">{errorAddress}</div>
                    )}
                  </div>
                </div>

                <div className="patient_form_row_container">
                  <div className="patient_form_one_item">
                    <div className="select_wrapper_settings">
                      <div className="info_title">Country</div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div>
                          <Select
                            placeholder={"Select Country"}
                            selectOptions={countryList}
                            initVal={
                              selectedCountry === "USA"
                                ? "United States"
                                : selectedCountry
                            }
                            selectCallback={function (callVal, value) {
                              handleCountrySelected(callVal, value);
                            }}
                            callBackValue={setSelectedCountry}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="patient_form_one_item">
                    <div className="select_wrapper_settings">
                      <div className="info_title">
                        {selectedCountry === "Canada"
                          ? "Province with time zone"
                          : "State"}
                      </div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div>
                          <Select
                            placeholder={"Select State"}
                            selectOptions={
                              selectedCountry === "United States"
                                ? unitedStateStateList
                                : canadaStateList
                            }
                            initVal={selectedState}
                            selectCallback={function (callVal, value) {
                              handlStateSelected(callVal, value);
                            }}
                            callBackValue={setSelectedState}
                            selectError={!selectedState && errorSelectedState}
                          />
                        </div>
                      </div>
                    </div>
                    {!selectedState && errorSelectedState && (
                      <div className="email_error_msg">
                        {errorSelectedState}
                      </div>
                    )}
                  </div>
                </div>

                <div className="patient_form_row_container">
                  <div className="patient_form_one_item">
                    <div className="info_title">City</div>
                    <input
                      type="text"
                      value={city}
                      className="patient_info_input"
                      onChange={(e) => handleCity(e.currentTarget.value)}
                    />
                    {errorCity && (
                      <div className="email_error_msg">{errorCity}</div>
                    )}
                  </div>

                  <div className="patient_form_one_item">
                    <div className="info_title">Zip code</div>
                    <input
                      type="text"
                      value={zipCode}
                      className="patient_info_input"
                      onChange={(e) => handleZipCode(e.currentTarget.value)}
                    />
                    {errorZipCode && (
                      <div className="email_error_msg">{errorZipCode}</div>
                    )}
                  </div>
                </div>

                <div className="patient_form_row_container">
                  <div className="patient_form_one_item">
                    <div className="select_wrapper_settings">
                      <div className="info_title">Gender</div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div>
                          <Select
                            selectOptions={genderList}
                            initVal={patientSettings.gender}
                            selectCallback={function (callVal, value) {
                              handleGenderSelected(callVal, value);
                            }}
                            callBackValue={setGenderValue}
                            //selectError={!stateSelected && stateSelectedError}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="patient_form_one_item">
                    <div className="info_title">Height (feet)</div>
                    <input
                      type="text"
                      value={height}
                      className="patient_info_input"
                      onChange={(e) => handleHeight(e.currentTarget.value)}
                    />
                    {errorHeight && (
                      <div className="email_error_msg">{errorHeight}</div>
                    )}
                  </div>

                  <div className="patient_form_one_item">
                    <div className="info_title">Weight (lbs)</div>
                    <input
                      type="text"
                      value={weight}
                      className="patient_info_input"
                      onChange={(e) => handleWeight(e.currentTarget.value)}
                    />
                    {errorWeight && (
                      <div className="email_error_msg">{errorWeight}</div>
                    )}
                  </div>
                </div>
              </>
            )}
            {/*selectedTab === "notifications" && (
              <>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">Daily Tasks</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " + (patientSettings.dailyTasks ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div className="notifications_types">
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.dailyTasksNotification ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">Notifications</span>
                    </div>
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.dailyTasksSms ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">SMS</span>
                    </div>
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.dailyTasksEmail ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">Email</span>
                    </div>
                  </div>
                  <input type="text" className="notifications_value" value={patientSettings.dailyTasksValue} />
                </div>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">Appointment Reminder</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " +
                          (patientSettings.appointmentReminder ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div className="notifications_types">
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.appointmentReminderNotification ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">Notifications</span>
                    </div>
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.appointmentReminderSms ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">SMS</span>
                    </div>
                    <div className="one_checkbox">
                      <div
                        className={
                          "questionare_checkbox " +
                          (patientSettings.appointmentReminderEmail ? "questionare_checkbox_selected" : "")
                        }
                      ></div>
                      <span className="notification_type_span">Email</span>
                    </div>
                  </div>
                  <div className="notification_select_holder">
                    <div className="relative_holder reg_select_wrapper mg-5 notifications_inline">
                      <div>
                        <Select
                          selectOptions={timeValues}
                          initVal={patientSettings.appointmentReminderValue}
                          selectCallback={function (callVal, value) {
                            handlStateSelected(callVal, value);
                          }}
                          callBackValue={setSelectedState}
                          //selectError={!stateSelected && stateSelectedError}
                        />
                      </div>
                    </div>
                    <div className="relative_holder reg_select_wrapper mg-5 notifications_inline ml-20">
                      <div>
                        <Select
                          selectOptions={timeValuesFormat}
                          initVal={patientSettings.appointmentReminderType}
                          selectCallback={function (callVal, value) {
                            handlStateSelected(callVal, value);
                          }}
                          callBackValue={setSelectedState}
                          //selectError={!stateSelected && stateSelectedError}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">Progress Reminder</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " +
                          (patientSettings.appointmentReminder ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <input type="text" className="notifications_value" />
                </div>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">Daily Progress</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " + (patientSettings.dailyProgres ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <input type="text" className="notifications_value" value={patientSettings.dailyProgresTime} />
                </div>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">End of Week Progress</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " +
                          (patientSettings.endOfWeekProgress ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div className="notification_select_holder">
                    <div className="relative_holder reg_select_wrapper mg-5 notifications_inline">
                      <div>
                        <Select
                          selectOptions={endOfWeekTimeValues}
                          initVal={patientSettings.endOfWeekDay}
                          selectCallback={function (callVal, value) {
                            handlStateSelected(callVal, value);
                          }}
                          callBackValue={setSelectedState}
                          //selectError={!stateSelected && stateSelectedError}
                        />
                      </div>
                    </div>
                    <input type="text" className="notifications_value" value={patientSettings.endOfWeekTime} />
                  </div>
                </div>
                <div className="notification_option">
                  <div className="notification_header">
                    <div className="notification_title">Messages</div>
                    <div className="notification_toggle">
                      <div
                        className={
                          "abr_switch " +
                          (patientSettings.messagesNotifications ? "abr_switch_active" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
                      )*/}
          </div>
        </div>
        {/* </div> */}
      </div>
      {errorPopUp && (
        <div
          className={
            "prog_err_hold" +
            (errorPopUp === "Info have been successfully saved."
              ? " prog_pop_pat_correct"
              : "")
          }
        >
          <div
            className={
              errorPopUp === "Info have been successfully saved."
                ? "prog_pop_icon_correct"
                : "prog_err_icon"
            }
          ></div>
          <div
            className={
              "prog_err_text" +
              (errorPopUp === "Info have been successfully saved."
                ? " prog_pop_text_correct"
                : "")
            }
          >
            {errorPopUp}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientSettings;
